import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const InvitationContainer = styled("div")(({ theme }) => ({
  border: "1px solid #111",
  padding: theme.spacing(1),
}));
const MessageTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(1.5),
}));

type NetworkInvitationFormProps = {
  message: string;
  onMessageChange: (message: string) => void;
  onCancel: () => void;
  onSend: () => void;
};

/** The optional note sent with a network invitation, and the two buttons that close it. */
export default function NetworkInvitationForm(props: Readonly<NetworkInvitationFormProps>) {
  const { message, onMessageChange, onCancel, onSend } = props;

  return (
    <InvitationContainer>
      <Stack>
        <Grid>
          <MessageTextField
            multiline
            variant="outlined"
            minRows={3}
            maxRows={6}
            fullWidth
            label="Message (optional)"
            value={message}
            onChange={(event) => onMessageChange(event.target.value)}
          />
        </Grid>
        <Grid>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" onClick={onSend}>
            Send Invitation
          </Button>
        </Grid>
      </Stack>
    </InvitationContainer>
  );
}
